export class LongStayRate {
	id: number;
	superhogUserId: string;
	/** PerStay (1) or PerNight (2): the S&P levels it applies to. */
	pricingCardTypeId: number;
	/** Null = every level on the basis (all-levels row); set = that level only, and it wins. */
	protectionLevelId?: number | null;
	currencyId: number;
	/** Nights the level's price covers. Null with rate = "No long stay" (level rows only). */
	nightThreshold: number | null;
	/** Per night, for every night after nightThreshold. */
	rate: number | null;
	startDate: Date | string;
	endDate?: Date | string | null;
	createdDate: Date | string;
	updatedDate?: Date | string | null;
}
